import { Region } from '@/api/region/types';

export const renderCity = (region: Region) => {
    return region.kind !== 'country' ? `${region.name}, ${region.parent_name}` : region.name;
};
